export const DAILY_NAV_COMPANY_VERSION_HISTORY_TEST_IDS = {
  versionHistoryItem: (versionId?: number) => `daily-monitoring__version-${versionId}`,
  versionHistoryCurrentChip: (versionId?: number) => `daily-monitoring__version-current-${versionId}`,
  versionHistoryLoadMore: 'daily-monitoring__version-history-load-more',
  historyCompsList: (versionId?: number) => `daily-monitoring__history-comps-${versionId}`,
  historyNoCompsHint: (versionId?: number) => `daily-monitoring__history-no-comps-${versionId}`,
} as const;
